import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    console.log('Google Analytics initialized');
  }
};

// Track page views
export const logPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const logEvent = (category, action, label = '', value = 0) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  logEvent('Button', 'Click', buttonName);
};

// Track downloads
export const trackDownload = (fileName) => {
  logEvent('Download', 'File', fileName);
};

// Track external links
export const trackExternalLink = (url) => {
  logEvent('External Link', 'Click', url);
};

// Track form submissions
export const trackFormSubmit = (formName) => {
  logEvent('Form', 'Submit', formName);
};

// Track errors
export const trackError = (errorMessage) => {
  logEvent('Error', 'Exception', errorMessage);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  logEvent('Social Media', 'Click', platform);
};

// Track project views
export const trackProjectView = (projectName) => {
  logEvent('Project', 'View', projectName);
};

// Track contact attempts
export const trackContact = (method) => {
  logEvent('Contact', 'Attempt', method);
};
